window.str_slug = function (str) {
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/\,/g, '-');
  str = str.replace(/\./g, '-');
  str = str.replace(/\ /g, '-');
  str = str.replace(/\;/g, '-');
  str = str.replace(/\\/g, '-');
  str = str.replace(/\!/g, '-');
  str = str.replace(/\@/g, '-');
  str = str.replace(/\#/g, '-');
  str = str.replace(/\$/g, '-');
  str = str.replace(/\%/g, '-');
  str = str.replace(/\^/g, '-');
  str = str.replace(/\&/g, '-');
  str = str.replace(/\*/g, '-');
  str = str.replace(/\:/g, '-');
  str = str.replace(/\?/g, '-');
  str = str.replace(/\]/g, '-');
  str = str.replace(/\[/g, '-');
  str = str.replace(/\)/g, '-');
  str = str.replace(/\(/g, '-');
  str = str.replace(/\=/g, '-');
  str = str.replace(/\+/g, '-');
  str = str.replace(/\~/g, '-');
  str = str.replace(/\"/g, '-');
  str = str.replace(/\'/g, '-');
  str = str.replace(/\|/g, '-');
  str = str.replace(/\`/g, '-');
  str = str.replace(/\//g, '-');
  str = str.replace(/\}/g, '-');
  str = str.replace(/\{/g, '-');
  str = str.replace(/----------/g, '-');
  str = str.replace(/---------/g, '-');
  str = str.replace(/--------/g, '-');
  str = str.replace(/-------/g, '-');
  str = str.replace(/------/g, '-');
  str = str.replace(/-----/g, '-');
  str = str.replace(/----/g, '-');
  str = str.replace(/---/g, '-');
  str = str.replace(/--/g, '-');
  return str;
};

window.replaceNumberWithCommas = function (yourNumber) {
  //Seperates the components of the number
  var n = yourNumber.toString().split('.');
  //Comma-fies the first part
  n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  //Combines the two sections
  return n.join('.');
};

window.number_format = function (number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? '.' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + (Math.round(n * k) / k).toFixed(prec);
    };
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
};

window.formatCurrency = function (elementDisplay, value) {
  $(elementDisplay).text(replaceNumberWithCommas(value));
};

window.price_format = function (value) {
  return replaceNumberWithCommas(value);
};

window.str_to_number = function (str) {
  let num = str.replaceAll(',', '');
  return parseInt(num);
};

window.getLocalData = function (key) {
  const data = localStorage.getItem(key);
  if (!data) return null;

  const storageData = JSON.parse(data);

  if (typeof storageData.expires !== 'undefined' && storageData.expires > 0) {
    const now = parseInt(new Date().getTime() / 1000);
    if (now > storageData.expires) {
      localStorage.removeItem(key);
      return null;
    }
  }

  return typeof storageData.data !== 'undefined' ? storageData.data : storageData;
};

window.setLocalData = function (key, data, expires = 0) {
  localStorage.removeItem(key.replace('V2', 'V1'));
  storageData = {
    data: data.toString(),
    time: expires,
  };
  localStorage.setItem(key, JSON.stringify(storageData));
};
